<template>
  <div
    v-if="notificationList.length > 0"
    id="alerts"
    @click="toggle"
    v-on-clickaway="away"
  >
    <div class="half">
      <label for="profile3" class="profile-dropdown">
        <input type="checkbox" id="profile3" />
        <label for="profile3">
          <notification-bell
            :size="30"
            :count="notificationList.length"
            :animated="true"
            upperlimit="50"
            counterlocation="upperright"
            counterstyle="roundrectangle"
            counterbackgroundcolor="#ff0000"
            countertextcolor="#ffffff"
            iconcolor="#000000"
          />
        </label>
        <ul>
          <li>
            <vue-simple-notify
              :items="notificationList"
              :delay="delay"
              @onDismiss="onDismiss"
            ></vue-simple-notify>
          </li>
        </ul>
      </label>
    </div>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway'
import NotificationBell from 'vue-notification-bell'
import VueSimpleNotify from 'vue-simple-notify'
import axios from 'axios'

export default {
  name: '#alerts',
  components: {
    NotificationBell,
    VueSimpleNotify
  },
  mixins: [clickaway],
  provide() {
    return {
      sharedState: this.sharedState
    }
  },
  data() {
    return {
      sharedState: {
        active: false
      },
      delay: 1000,
      notificationList: [],
      items: [
        {
          type: 'Low stock!',
          color: 'red',
          message: 'UnitName: productName (currentStock/maxStock)'
        },
        {
          type: 'New delivery order',
          color: '#3498db',
          message: 'UnitName: quantity x productName (shippingAddress)'
        }
      ]
    }
  },
  mounted() {
    this.convertNotifications()
  },
  methods: {
    async toggle() {
      this.sharedState.active = !this.sharedState.active
      if (document.getElementById('profile3').checked === true) {
        await this.$parent.fetchNotificationDetails()
        this.convertNotifications()
      }
    },
    away() {
      this.sharedState.active = false
      document.getElementById('profile3').checked = false
    },
    logout() {
      this.$store.dispatch('logout')
    },
    async onDismiss(index) {
      await axios
        .post(`${process.env.VUE_APP_API_URL}/notification/read`, [
          this.notificationList[index].id
        ])
        .then(() => {
          this.notificationList.splice(index, 1)
        })
    },
    convertNotifications() {
      this.notificationList = []
      this.notifications.forEach(notification => {
        const item = {}
        item.id = notification.id
        item.type = notification.title
        item.color = notification.color_code
        item.message = notification.notification
        this.notificationList.push(item)
      })
    }
  },
  props: {
    notifications: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss" scoped>
$border-radius: 3px;
$primary: #f2f2f2e3;
$animation: pulse;

.lang-dashboard {
  background-color: var(--bg);
}
.profile-dropdown {
  display: inline-block;
  position: absolute;
  right: 220px;
  top: 15px;
  // background: $primary;
  margin: auto;
  font-weight: bold;
  font-size: 1rem;
  border-radius: $border-radius;
  -webkit-user-select: none; /* Chrome all / Safari all */
  -moz-user-select: none; /* Firefox all */
  -ms-user-select: none; /* IE 10+ */
  user-select: none; /* Likely future */

  * {
    -webkit-user-select: none; /* Chrome all / Safari all */
    -moz-user-select: none; /* Firefox all */
    -ms-user-select: none; /* IE 10+ */
    user-select: none; /* Likely future */
  }

  input[type='checkbox'] {
    display: none;
    &:checked {
      & ~ ul {
        display: block;
        animation: $animation 0.5s;
      }

      & ~ img {
        background: var(--primary);
      }

      & ~ label {
        background: var(--bg);

        i {
          color: $primary;
        }

        &:after {
          content: '';
          position: absolute;
          top: 100%;
          right: calc(50% - 10px);
          display: block;
          border-style: solid;
          border-width: 7px 10px 0 10px;
          border-color: var(--bg) transparent transparent transparent;
          width: 0;
          height: 0;
        }
      }
    }
  }

  img {
    display: inline-block;
    background: darken($primary, 10%);
    height: 2.5rem;
    vertical-align: middle;
    margin-right: 1rem;
    margin: 0.5rem 0.75rem 0.5rem 0.5rem;
    border-radius: 50%;
  }

  span {
    display: inline-block;
    vertical-align: middle;
    // width: 125px;
    // margin-right:2rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  ul {
    display: none;
    list-style: none;
    padding: 0;
    margin: 0;
    background: var(--grey-light);
    position: absolute;
    top: 100%;
    right: 0;
    width: 600%;
    border-radius: $border-radius;

    li {
      margin: 20px;
    }
  }

  & > label {
    position: relative;
    height: 3rem;
    display: block;
    text-decoration: none;
    background: transparent;
    color: #333;
    box-sizing: border-box;
    padding: 0.65rem;
    float: right;
    border-radius: 0 $border-radius $border-radius 0;

    i {
      color: darken($primary, 25%);
      font-size: 1.75rem;
    }
  }

  &:after {
    content: '';
    display: table;
    clear: both;
  }
}

/// TEMPLATE STYLING
$background: #2c3e50;

body {
  background: $background;
  font-family: Lato;
}

h1 {
  text-align: center;
  font-size: 3rem;
  color: rgba(0, 0, 0, 0.5);
  text-transform: uppercase;
  margin: 2rem 0 0;
  letter-spacing: 0.5rem;
}

.container {
  width: 80%;
  margin: 4rem auto 2rem;

  .half {
    width: 50%;
    float: left;
    margin-bottom: 2rem;
  }

  &:after {
    content: '';
    display: table;
    clear: both;
  }
}

p.subtitle {
  color: rgba(0, 0, 0, 0.5);
  font-weight: bold;
  text-align: center;
  margin: 0.5rem 0 2rem;
  letter-spacing: 0.1rem;
}

.background {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  opacity: 0.25;
  z-index: -1;
  background: url(https://ar1web-com.googlecode.com/svn/Bg/bg63.gif);
}
@media screen and (max-width: 600px) {
  .profile-dropdown {
    left: 0;
    right: inherit;
    margin-left: 10px;
  }
  .profile-dropdown img {
    display: none;
  }
  .profile-dropdown span {
    margin: 17px 2px 16px 7px;
  }
  .profile-dropdown ul {
    left: 0%;
  }
}
</style>
